'use strict';

import moment from 'angular-moment';

import CompareWeatherLogic from '../compare_weather/compare_weather.logic';

export class CsvUtil {
  /*@ngInject*/
  constructor($filter, moment, CompareWeatherLogic) {
    this.$filter = $filter;
    this.moment = moment;
    this.CompareWeatherLogic = CompareWeatherLogic;
  }

  processEvent(eventList) {
    let csv = '発生日時,サービスコード,設置場所,メモ,イベント名\r\n'
    eventList.forEach(event => {
      csv += `${this.formatTimeBystr(event.occurred_at)},${event.pms_service_code},${event.location},${event.memo},${event.event_msg}\r\n`;
    });

    return csv;
  }

  processOemEvent(eventList) {
    let csv = '発生日時,顧客名,サービスコード,設置場所,メモ,イベント名\r\n'

    eventList.forEach(event => {
      csv += `${this.formatTimeBystr(event.occurred_at)},${event.company_name},${event.pms_service_code},${event.location},${event.memo},${event.event_msg}\r\n`;
    });

    return csv;
  }

  createEventReportCsv(events) {
    const eventList = [];
    for (let dayEvent of events) {
      for (let event of dayEvent.events) {
        eventList.push(event);
      }
    }

    return this.processEvent(eventList);
  }

  processDemandPower(powers, categories, targetDate, missingTimes = [], weathers) {
    let measuredTimes = this.formatCategories(categories, targetDate);

    let csv = '計測日時,需要電力(kW),天候,平均気温(℃),最高気温(℃),最低気温(℃)\r\n';
    powers.forEach((power, index) => {
      let powerStr = (power === null || this.isNoDataTime(categories[index], missingTimes)) ? 'データ無し' : power;

      // 天候情報は６時間ごとにデータが更新されている
      const weatherIndex = parseInt(index / 12);

      csv += `${measuredTimes[index]},${powerStr},${this.createWeatherColumn(weathers[weatherIndex])}\r\n`
    });

    return csv;
  }

  processBulkDemandPower(powers, weathers) {
    let csv = '計測日時,需要電力(kW),天候,平均気温(℃),最高気温(℃),最低気温(℃)\r\n';

    const formattedWeathers = this.formattedWeathers(powers, weathers);

    powers.forEach((power, index) => {
      // 天候情報は６時間ごとにデータが更新されている
      const weatherIndex = parseInt(index / 12);

      let powerStr;
      if (power.missing) {
        powerStr = 'データなし';
      } else {
        powerStr = power.value;
      }

      csv += `${this.moment(power.measured_at).format('YYYY/MM/DD HH:mm:ss')},${powerStr},${this.createWeatherColumn(formattedWeathers[weatherIndex])}\r\n`;
    });

    return csv;
  }

  processActivePower(powers, categories, targetDate, missingTimes, noCalculateTimes, weathers) {
    let measuredTimes = this.formatCategories(categories, targetDate);

    let csv = '計測日時,消費電力(kWh),天候,平均気温(℃),最高気温(℃),最低気温(℃)\r\n';
    powers.forEach((power, index) => {
      let powerStr = power;
      if (power === null || this.isNoDataTime(categories[index], missingTimes)) {
        powerStr = 'データ無し';
      } else if (this.isNoDataTime(categories[index], noCalculateTimes)) {
        powerStr = '差分計算不可';
      }

      // 天候情報は６時間ごとにデータが更新されている
      const weatherIndex = parseInt(index / 12);

      csv += `${measuredTimes[index]},${powerStr},${this.createWeatherColumn(weathers[weatherIndex])}\r\n`
    });

    return csv;
  }

  processBulkActivePower(powers, weathers) {
    let csv = '計測日時,消費電力(kWh),天候,平均気温(℃),最高気温(℃),最低気温(℃)\r\n';

    const formattedWeathers = this.formattedWeathers(powers, weathers);

    powers.forEach((power, index) => {
      // 天候情報は６時間ごとにデータが更新されている
      const weatherIndex = parseInt(index / 12);

      let powerStr;
      if (index === 0) {
        return;
      } else if (power.missing) {
        powerStr = 'データ無し';
      } else if (powers[index - 1].missing) {
        powerStr = '差分計算不可';
      } else {
        powerStr = power.value - powers[index - 1].value;
      }

      csv += `${this.moment(power.measured_at).format('YYYY/MM/DD HH:mm:ss')},${powerStr},${this.createWeatherColumn(formattedWeathers[weatherIndex])}\r\n`;
    });

    return csv;
  }

  processMaxDemandPower(powers, categories, weathers) {
    let csv = '集計日,需要電力(kW),天候,平均気温(℃),最高気温(℃),最低気温(℃)\r\n';

    powers.forEach((power, index) => {
      let powerStr = (power === null) ? 'データなし' : power;
      csv += `${this.formatDate(categories[index])},${powerStr},${this.createWeatherColumn(weathers[index])}\r\n`
    });

    return csv;
  }

  processDailyActivePower(powers, categories, weathers) {
    let csv = '集計日,消費電力(kWh),天候,平均気温(℃),最高気温(℃),最低気温(℃)\r\n';

    powers.forEach((power, index) => {
      let powerStr = (power === null) ? 'データなし' : power;
      csv += `${this.formatDate(categories[index])},${powerStr},${this.createWeatherColumn(weathers[index])}\r\n`
    });

    return csv;
  }

  processMonthlyMaxDemandPower(powers, categories) {
    let csv = '集計月,需要電力(kW)\r\n';
    powers.forEach((power, index) => {
      let powerStr = (power === null) ? 'データなし' : power;
      csv += `${this.formatDateMonth(categories[index])},${powerStr}\r\n`
    });

    return csv;
  }

  processMonthlyActivePower(powers, categories) {
    let csv = '集計月,消費電力(kWh)\r\n';
    powers.forEach((power, index) => {
      let powerStr = (power === null) ? 'データなし' : power;
      csv += `${this.formatDateMonth(categories[index])},${powerStr}\r\n`
    });

    return csv;
  }

  processDemandHistogram(histogram) {
    let csv = '需要電力(kW),発生回数\r\n';

    histogram.forEach(data => {
      csv += `${ data.x },${ data.y }\r\n`
    });

    return csv;
  }

  processGroupActivePower(seriesList, categories, targetDate) {
    let measuredTimes = this.formatCategories(categories, targetDate);

    let csv = '計測日時,サービスコード,消費電力(kWh),設置場所,メモ\r\n';
    seriesList.forEach((series) => {
      series.data.forEach((power, index) => {
        csv += `${measuredTimes[index]},${series.name},${power.y},${series.location},${series.memo}\r\n`;
      });
    });

    return csv;
  }

  processDailyGroupActivePower(seriesList, categories) {
    let csv = '集計日,サービスコード,消費電力(kWh),設置場所,メモ\r\n';
    seriesList.forEach((series) => {
      series.data.forEach((power, index) => {
        csv += `${this.formatDate(categories[index])},${series.name},${power.y},${series.location},${series.memo}\r\n`;
      });
    });

    return csv;
  }

  formatTimeBystr(timeStr) {
    return (this.formatTime(Date.parse(timeStr)));
  }

  formatTime(time) {
    return this.$filter('date')(time, 'yyyy/MM/dd HH:mm:ss');
  }

  formatDate(date) {
    return this.$filter('date')(date, 'yyyy/MM/dd');
  }

  formatDateMonth(date) {
    return this.$filter('date')(date, 'yyyy年MM月');
  }

  formatCategories(categories, targetDate) {
    let target = this.moment(targetDate).startOf('day');
    return categories.map(time => {
      target.add(30, 'minutes');
      return `${target.format('YYYY/MM/DD HH:mm:ss')}`;
    });
  }

  formattedWeathers(powers, weathers) {
    const currentTime = this.moment(powers[0].measured_at).startOf('day').add(3, 'hours');
    const endTime = this.moment(powers[powers.length - 1]).startOf('day').add(21, 'hours');

    const samplingTimes = [];
    while(currentTime <= endTime) {
      samplingTimes.push(currentTime.format('YYYY-MM-DD HH:mm:ss'));
      currentTime.add(6, 'hours');
    }

    return this.CompareWeatherLogic.compareDateTime(weathers, samplingTimes);
  }

  isNoDataTime(time, noDataTimes) {
    return noDataTimes.indexOf(time) !== -1
  }

  createWeatherColumn(weather) {
    let weatherName = 'データなし';
    let temp = 'データなし';
    let tempMax = 'データなし';
    let tempMin = 'データなし';

    if (weather) {
      weatherName = this.$filter('weather-name')(weather.code);
      temp = weather.temp;
      tempMax = weather.temp_max;
      tempMin = weather.temp_min;
    }

    return weatherName + ',' + temp + ',' + tempMax + ',' + tempMin;
  }
}

export default angular.module('leptonApp.CsvUtil', [moment, CompareWeatherLogic])
  .service('CsvUtil', ['$filter', 'moment', 'CompareWeatherLogic', CsvUtil])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/logic/csv_util/csv.util.js